import { ReactNode, useState, MouseEvent, Key } from 'react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export interface MoreActionsDropdownProps extends Pick<IconButtonProps, 'size' | 'color'> {
  actions: {
    key: Key;
    onClick: (event: MouseEvent<HTMLElement>) => void;
    content: ReactNode;
    disabled?: boolean;
  }[];
}

export const MoreActionsDropdown = ({ actions, size, color }: MoreActionsDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-controls={open ? 'more-actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size={size}
        color={color}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'more-actions-menu',
            dense: size === 'small',
          },
        }}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.key}
            onClick={(event) => {
              action.onClick(event);
              if (!event.isPropagationStopped()) {
                handleClose();
              }
            }}
            disabled={action.disabled}
          >
            {action.content}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
